import React, {useState} from 'react'
import GenerateVerification from './GenerateVerification'

export default function Verification(props) {
    const [values, setValues] = React.useState({
        email: '',
        mobile: '',
        verificationType: 'email',
        message: ''
    });

    let getData = (prop, data) => {
        setValues({...values, [prop]: data})
    }

    const [urlParams, setUrlParams] = useState('');

    React.useEffect(() => {
        setUrlParams(props.type);
    }, [props.type])

    // console.log(values);

    return (
        <main className="verification">
            <GenerateVerification
                colors={{...props.colors}}
                orgId={props.orgId}
                pencil={props.pencil}
                unicycle={props.unicycle}
                urlParams={urlParams}
                getData={getData}
                rsvpLabel={props.rsvpLabel || ''}
            />
        </main>
    )
}
